export const init = function (url) {
  if (!window.extole) {
    const extole = document.createElement('script')
    extole.type = 'text/javascript'
    extole.async = true
    extole.src = url
    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(extole, firstScript)
  }
}
